import React from "react";

import { Col, Row } from "reactstrap";

import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import {
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

import { loadOptions } from "common/enums";
import InputFieldText from "Components/Common/InputFieldText";
import SelectField from "Components/Common/SelectField";
import { onlyNumberKeys } from "utils";

const ConnectionLoadDetails = ({ formik, t }) => {
  const {
    values: {
      connectionLoad: { backupPowerAlteration },
    },
    setFieldValue,
  } = formik;

  return (
    <>
      <Typography className="mb-3" lineHeight="1" variant="h6">
        {t("Load Details")}:
      </Typography>
      <Row>
        <Col md={4} sm={6}>
          <SelectField
            label={t("Phase")}
            name="connectionLoad.loadDetails"
            options={loadOptions}
            getOptionLabel={(option) => option.label}
            formik={formik}
            disabled
          />
        </Col>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Supply Voltage")}
            name="connectionLoad.supplyVoltage"
            formik={formik}
            disabled
          />
        </Col>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Contract Load")}
            name="connectionLoad.powerRequirement"
            formik={formik}
            disabled
          />
        </Col>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Backup Power")}
            name="extraValues.exisingbackupkVA"
            formik={formik}
            disabled
          />
        </Col>
      </Row>

      <Row>
        <FormControl>
          <RadioGroup
            onChange={(e) => {
              setFieldValue(
                "connectionLoad.backupPowerAlteration",
                +e.currentTarget.value
              );
            }}
          >
            <Row className="m-1">
              {formik.values.extraValues.exisingbackupkVA === "" ? (
                <>
                  <Col md={4}>
                    <FormControlLabel
                      control={<Radio />}
                      value={1}
                      label={t("Add Load")}
                      name="connectionLoad.backupPowerAlteration"
                      checked={backupPowerAlteration === 1}
                    />
                  </Col>
                </>
              ) : (
                <>
                  <Col md={4}>
                    <FormControlLabel
                      control={<Radio />}
                      value={2}
                      label={t("Change Load")}
                      formik={formik}
                      name="connectionLoad.backupPowerAlteration"
                      checked={backupPowerAlteration === 2}
                    />
                  </Col>

                  <Col md={4}>
                    <FormControlLabel
                      control={<Radio />}
                      value={3}
                      label={t("SurrenderLoad")}
                      name="connectionLoad.backupPowerAlteration"
                      checked={backupPowerAlteration === 3}
                    />
                  </Col>
                </>
              )}
              <Row>
                <Col md={4} sm={6}>
                  <InputFieldText
                    label={t("Backup kVA")}
                    formik={formik}
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">kVA</InputAdornment>
                      ),
                      inputProps: { min: 0, onKeyDown: onlyNumberKeys },
                    }}
                    name="connectionLoad.backupkVA"
                    disabled={backupPowerAlteration === 3}
                  />
                </Col>
              </Row>
            </Row>
          </RadioGroup>
        </FormControl>
      </Row>
    </>
  );
};
ConnectionLoadDetails.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
};
export default withTranslation()(ConnectionLoadDetails);
